import React, {Suspense, Fragment, lazy} from 'react';
import {Router, useLocation, Redirect} from 'react-router-dom';
import {history} from './history';

import {Switch, Route} from 'react-router';
import {TransitionGroup, CSSTransition} from 'react-transition-group';
import {Provider, connect} from 'react-redux';
import './Router.less';
import {ABOUT, CART, ORDER, RESTAURANT} from 'new-constants/routes.constants';
import {getStartupParams} from 'helpers/startup-params.helper';
import Platform from '../../platform';

import {ErrorBoundary} from 'new-components/error-boundary/ErrorBoundary';
import {ClientLogErrorBoundary} from "../../managers/client-log.manager";
// const RestaurantPage = lazy(() => import('new-components/pages/restaurant/RestaurantPage'));
// const AboutPage = lazy(() => import('new-components/pages/about/AboutPage'));
// const CartPage = lazy(() => import('new-components/pages/cart/CartPage'));
// const OrderPage = lazy(() => import('new-components/pages/order/OrderPage'));


import RestaurantPage from 'new-components/pages/restaurant/RestaurantPage';
import AboutPage from 'new-components/pages/about/AboutPage';
import CartPage from 'new-components/pages/cart/CartPage.jsx';
import OrderPage from 'new-components/pages/order/OrderPage.jsx';
import ErrorPage from 'new-components/pages/error/ErrorPage';
import {getSafeTranslation} from 'helpers/localization.helper.ts';
import CssDisplay from 'compositions/css-display/CssDisplay';

import {syncHistoryWithStore} from 'react-router-redux';
import {getRouteByPathname} from "../../helpers/routes.helper";

const NonDefaultRoute = connect(({appState}) => ({appState}))(({children, appState, ...rest}) => {
	return <Route
		{...rest}
		render={({location}) =>
			appState.isAppStarted ? (
				children
			) : (
				<Redirect
					to={RESTAURANT.replace('/:entryIdToExpand?', '')}
				/>
			)
		}
	/>
});

const App = () => {
	let location = useLocation();

	return (
		<Suspense fallback={<div>Loading...</div>}>
			<Fragment>
				<CssDisplay/>
				<TransitionGroup>
					{/*
            This is no different than other usage of
            <CSSTransition>, just make sure to pass
            `location` to `Switch` so it can match
            the old location as it animates out.
          */}
					<CSSTransition key={getRouteByPathname(location.pathname)} classNames="fade" timeout={300}>
						<Switch location={location}>
							<Route exact path="/">
								<RestaurantPage/>
							</Route>
							<Route exact path={RESTAURANT}>
								<RestaurantPage/>
							</Route>
							<NonDefaultRoute exact path={ABOUT}>
								<AboutPage/>
							</NonDefaultRoute>
							<NonDefaultRoute exact path={CART}>
								<CartPage/>
							</NonDefaultRoute>
							<NonDefaultRoute exact path={ORDER}>
								<OrderPage/>
							</NonDefaultRoute>
							<Route>
								<RestaurantPage/>
							</Route>
						</Switch>
					</CSSTransition>
				</TransitionGroup>
			</Fragment>
		</Suspense>
	);
};

export const AppRouter = ({store}) => {
	const routerHistory = syncHistoryWithStore(history, store)

	if (!Platform.isNativeApp && !getStartupParams().app && !getStartupParams().id) {
		return (
			<Provider store={store}>
				<div className="router">
					<ErrorPage
						errorMessage={getSafeTranslation(
							'ErrorPage.restaurantNotSpecifiedMessage',
							store.getState().localization.translations
						)}
					/>
				</div>
			</Provider>
		);
	}

	const platformClasses = Platform.getClasses().join(' ');

	return (
		<ClientLogErrorBoundary>
			<ErrorBoundary
				renderError={errorMessage => (
					<Provider store={store}>
						<div className={"router" + platformClasses}>
							<ErrorPage errorMessage={errorMessage}/>
						</div>
					</Provider>
				)}
			>
				<Provider store={store}>
					<Router history={routerHistory}>
						<div className={"router " + platformClasses}>
							<App/>
						</div>
					</Router>
				</Provider>
			</ErrorBoundary>
		</ClientLogErrorBoundary>
	);
};
